<template lang="pug">
div
  ArticleView(:article="article")
  .u-mb-md
  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('moreBlog')")

    Query(
      :query="require('~/graphql/Article.gql').Articles"
      :limit="limit"
      :variables="({ first, after }) => ({ first, after, publishedIn: scope, excluded: [article.id] })"
      @fetch="onFetch"
      :refetchOnRouteChange="true"
      v-slot="{ items }"
    )
      AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard.is-work(:img="[{ srcset: item.thumb, type: 'image/jpg', ratio }]" :ratio="ratio" :title="item.title" :url="`/articles/${item.slug}`")

  .u-mb-mi
</template>

<script>
import ArticleView from '~/components/views/ArticleView';
import { Article } from '~/graphql/Article.gql';
import { generateContentSeo, generateArticleSchema } from '~/utils/seo';
import labsMap from '~/assets/data/labs.json';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';

export default {
  scrollToTop: true,
  head() {
    const seo = generateContentSeo(this.article);
    seo.__dangerouslyDisableSanitizers = ['script'];
    seo.script = [
      {
        innerHTML: JSON.stringify(generateArticleSchema(this.article)),
        type: 'application/ld+json'
      }
    ];

    return seo;
  },
  components: {
    ArticleView,
    AsymetricGrid,
    Query
  },
  async asyncData({ app, params, error }) {
    try {
      const { data } = await app.$api.query({
        query: Article,
        variables: { slug: params.slug }
      });

      if (!data.article) {
        console.log('ddd');
        // return error({
        //   statusCode: 404,
        //   message: 'ARTICLE_NOT_FOUND'
        // });
      }

      app.verifyContentLocale(data.article);
      app.applyContentTheme(data.article);

      return {
        scope: labsMap[params.lab],
        lab: params.lab,
        limit: 2,
        article: data.article
      };
    } catch (err) {
      error({
        statusCode: 500,
        message: err.message
      });
    }
  },
  watch: {
    $route() {
      window.scroll({
        top: 0,
        left: 0
      });
    }
  },
  methods: {
    onFetch() {
      this.limit = 10;
    }
  }
};
</script>

<style lang="stylus">
.contentArea
  p
    margin-bottom: unitRes(20, 40)
</style>

<i18n>
{
  "en": {
    "moreBlog": "More Articles"
  },
  "ar": {
    "moreBlog": "المزيد من المقالات"
  }
}
</i18n>
